<template>
  <div class="message-text message-component">
    <div
      class="text-content"
      v-if="formattedContent && formattedContent.length"
    >
      <template v-for="(item, index) in formattedContent">
        <!-- 文本内容 -->
        <span
          v-if="item.type === 'text'"
          :key="'text-' + index"
          class="text-item"
          v-html="item.content"
        ></span>

        <!-- 图片内容 -->
        <img
          v-else-if="item.type === 'image'"
          :key="'img-' + index"
          :src="getOptimizedImageSrc(item.src)"
          class="emoji-img"
          :class="{ 'new-line': item.newLine }"
        />

        <!-- 换行 -->
        <br v-if="item.type === 'break'" :key="'br-' + index" />
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "MessageText",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formattedContent: [],
    };
  },
  computed: {
    messageData() {
      if (!this.data) {
        return [];
      }
      if (!this.data.text) {
        return [];
      }
      return Array.isArray(this.data.text) ? this.data.text : [];
    },
  },
  watch: {
    messageData: {
      handler(newVal) {
        if (newVal && newVal.length) {
          this.processTextData();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    processTextData() {
      const result = [];
      let needNewLine = false;

      for (let i = 0; i < this.messageData.length; i++) {
        const item = this.messageData[i];
        const nextItem =
          i < this.messageData.length - 1 ? this.messageData[i + 1] : null;

        if (item.name === "text") {
          if (!item.text) continue;

          // 检查是否以换行符结束
          const endsWithNewline = item.text.endsWith("\n");
          // 检查下一个是否为图片
          const nextIsImage = nextItem && nextItem.name === "img";

          // 处理文本内容
          if (item.text.includes("\n")) {
            const lines = item.text.split("\n");

            for (let j = 0; j < lines.length; j++) {
              const line = lines[j];
              const isLastLine = j === lines.length - 1;

              // 添加非空行文本
              if (line) {
                result.push({
                  type: "text",
                  content: line,
                });
              }

              // 处理换行
              if (!isLastLine || endsWithNewline) {
                // 特殊情况：如果是最后一个换行符且下一个是图片，不添加额外的换行符
                if (isLastLine && endsWithNewline && nextIsImage) {
                  needNewLine = true;
                } else {
                  result.push({ type: "break" });
                  needNewLine = true;
                }
              }
            }
          } else {
            // 没有换行符的文本
            result.push({
              type: "text",
              content: item.text,
            });
            needNewLine = false;
          }
        } else if (item.name === "img") {
          // 处理图片
          result.push({
            type: "image",
            src: item.src,
            newLine: needNewLine,
          });

          // 检查图片后是否有文本以换行符开始
          if (
            nextItem &&
            nextItem.name === "text" &&
            nextItem.text.startsWith("\n")
          ) {
            needNewLine = true;
          } else {
            needNewLine = false;
          }
        }
      }

      this.formattedContent = result;
    },
    // 判断一个字符串是否是链接
    isUrl(str) {
      if (!str) return false;
      return /^(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/.test(
        str
      );
    },
    getOptimizedImageSrc(src) {
      if (!src) return '';
      if (/^https?:\/\//.test(src)) {
        return src.includes('?') ? src + '&imageView2/0/w/40' : src + '?imageView2/0/w/40';
      }
      return src;
    },
  },
};
</script>

<style lang="scss" scoped>
.message-text {
  word-break: break-word;

  .text-content {
    display: inline;
    line-break: anywhere;
  }

  .text-item {
    white-space: pre-wrap;
    word-break: break-word;

    a {
      color: #386bff;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .emoji-img {
    display: inline-block;
    vertical-align: middle;
    max-width: 24px;
    max-height: 24px;
    margin: 0 2px;

    &.new-line {
      margin-left: 0;
    }
  }
}
</style>
